import { Stack } from "@mui/material";
import React from "react";

const Bullet = ({
  bottom,
  color,
  handleHeight = "14px",
  height,
  label,
  left,
  reverse,
  style,
  textColor: _textColor,
  top,
  transform,
  type,
  width,
}) => {
  return (
    <Stack
      className="absolute w-max capitalize"
      style={{
        bottom: reverse ? null : bottom,
        flexDirection: reverse ? "column-reverse" : "column",
        left: left,
        top: reverse ? top : null,
        transform: transform,
        zIndex: 99,
        ...style,
      }}
    >
      <div
        className="rounded-ds-0-25x !border-2 border-ds-strong font-ds-number-regular-xs"
        style={{
          borderColor: color,
          boxShadow: "var(--box-shadow-elevation-200)",
          maxWidth: "19rem",
          padding: "4px 8px 4px 8px",
        }}
      >
        {label}
      </div>
      <div
        className="border-ds-subtle"
        style={{
          height: handleHeight,
        }}
      />
      {type && (
        <div
          className="border-2 border-ds-subtle"
          style={{
            backgroundColor: color,
            borderRadius: type === "circle" ? "50%" : "0",
            height: height,
            width: width,
          }}
        />
      )}
    </Stack>
  );
};

export default Bullet;
